import { db } from "../../firebase";
import { collection, query, where, orderBy, limit, getDocs, startAfter, or, and } from "firebase/firestore";
import {
  USERS_PREPTALK_RESET,
  USERS_PREPTALK_LOAD_COACHES_REQUEST, USERS_PREPTALK_LOAD_COACHES_SUCCESS, USERS_PREPTALK_LOAD_COACHES_FAILURE,
  USERS_PREPTALK_LOAD_STUDENTS_REQUEST, USERS_PREPTALK_LOAD_STUDENTS_SUCCESS, USERS_PREPTALK_LOAD_STUDENTS_FAILURE,
} from "./UsersPrepTalkTypes";

const PAGE = 500;
export const usersReset = () => ({ type: USERS_PREPTALK_RESET });

async function fetchUsersPage({ roleIsCoach, pageSize, after }) {
  const col = collection(db, "users");
  const base = roleIsCoach
  ? query(
      col,
      or(
        where("coach", "==", true),
        where("coach", "==", "true")
      ),
      orderBy("email")
    )
  : query(
      col,
      and(
        or(
          where("coach", "==", false),
          where("coach", "==", "false"),
          where("coach", "==", null)
        ),
        where("ultimateAdvisingStudent", "in", [true, "true"])
      ),
      orderBy("email")
    );

  
  const q = after ? query(base, startAfter(after), limit(pageSize)) : query(base, limit(pageSize));
  const snap = await getDocs(q);
  const items = snap.docs.map(d => {
    
    
    return {
      id: d.id,
      email: (d.data().email || "").toLowerCase(),
      displayName: d.data().name || d.data().displayName || d.data().email,
      coach: !!d.data().coach,
      profilePicture: d.data().profilePicture || "",
      admin: d.data().admin || false,

    _snapRef: d,
  }});
  
  return { items, last: snap.docs[snap.docs.length - 1] || null, hasMore: snap.size === pageSize };
}

export const loadCoachesPage = ({ reset = false, pageSize = PAGE } = {}) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: USERS_PREPTALK_LOAD_COACHES_REQUEST, payload: { reset } });
      const after = reset ? null : getState().usersPreptalk.cursorCoaches;
      const { items, last, hasMore } = await fetchUsersPage({ roleIsCoach: true, pageSize, after });
      dispatch({ type: USERS_PREPTALK_LOAD_COACHES_SUCCESS, payload: { items, last, hasMore, reset } });
    } catch (err) {
      dispatch({ type: USERS_PREPTALK_LOAD_COACHES_FAILURE, payload: err.message });
    }
  };
};

export const loadStudentsPage = ({ reset = false, pageSize = PAGE } = {}) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: USERS_PREPTALK_LOAD_STUDENTS_REQUEST, payload: { reset } });
      const after = reset ? null : getState().usersPreptalk.cursorStudents;
      const { items, last, hasMore } = await fetchUsersPage({ roleIsCoach: false, pageSize, after });
      dispatch({ type: USERS_PREPTALK_LOAD_STUDENTS_SUCCESS, payload: { items, last, hasMore, reset } });
    } catch (err) {
      dispatch({ type: USERS_PREPTALK_LOAD_STUDENTS_FAILURE, payload: err.message });
    }
  };
};

export async function getUserDataByEmails(emails) {
  
  const q = query(collection(db, "users"), where("email", "in", emails));
  const snap = await getDocs(q);

  if (!snap.empty) {
    return snap.docs.map(doc => doc.data());
  }

  return [];
}
